/**
 * Entity-scoped permission keys - mirror of the backend catalog
 * (`common/constants/permissions.ts`). Features gate on these via `can()` /
 * `usePermission`, never on raw role/`canEdit` comparisons. Keys are frozen so
 * call sites are stable when granular resolution lands (AUTHZ-1).
 */
export const PERMISSIONS = {
  ENTITY_PROFILE_EDIT: 'entity.profile.edit',
  TEAM_MANAGE: 'team.manage',
  TEAM_INVITE: 'team.invite',
  EVENTS_MANAGE: 'events.manage',
  RESOURCES_MANAGE: 'resources.manage',
  BILLING_MANAGE: 'billing.manage',
  SHARES_MANAGE: 'shares.manage',
} as const;

export type PermissionKey = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];

export const ALL_PERMISSION_KEYS: readonly PermissionKey[] = Object.values(PERMISSIONS);
